<template>
  <div>
    <!-- Form Modal -->
    <b-modal
      id="modal-society-form"
      ref="myModal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      @ok="submit"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5>Register Grower</h5>

        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="primary"
          :disabled="saving"
          @click="ok()"
        >
          <b-spinner
            v-if="saving"
            small
            class="mr-1"
            label="Small Spinner"
          />
          <span v-if="!saving">Save</span>
          <span v-if="saving">Saving...</span>
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{}">
        <validation-observer
          ref="dataForm"
          #default="{ invalid }"
        >
          <b-form
            ref="form"
            @submit.stop.prevent="handleCreate"
          >
            <b-row>
              <b-col
                cols="12"
                md="6"
              >
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-row>
                      <b-col cols="12">
                        <b-avatar
                          :src="require('@/assets/images/avatars/1.png')"
                          size="140px"
                          rounded
                        />
                      </b-col>

                      <b-col
                        cols="12"
                        class="pt-16"
                      >
                        <b-form-group
                          labe-for="gender"
                          label="Gender"
                          style="cursor: pointer"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Gender"
                            rules=""
                          >
                            <b-form-select
                              id="gender"
                              v-model="grower.gender"
                              size="sm"
                              name="gender"
                              :state="errors.length > 0 ? false : null"
                            >
                              <b-form-select-option :value="null">
                                Select...
                              </b-form-select-option>
                              <b-form-select-option value="female">
                                Female
                              </b-form-select-option>
                              <b-form-select-option value="male">
                                Male
                              </b-form-select-option>
                            </b-form-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                            <small
                              v-if="serverErrors && serverErrors.gender"
                              class="text-danger"
                            >{{ serverErrors.gender[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-row>
                      <b-col cols="12">
                        <b-form-group
                          labe-for="firstName"
                          label="First Name"
                          style="cursor: pointer"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="First Name"
                            rules=""
                          >
                            <b-form-input
                              id="firstName"
                              v-model="grower.firstName"
                              name="firstName"
                              :state="errors.length > 0 ? false : null"
                              size="sm"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            <small
                              v-if="serverErrors && serverErrors.firstName"
                              class="text-danger"
                            >{{ serverErrors.firstName[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-0">
                      <b-col cols="12">
                        <b-form-group
                          labe-for="middleName"
                          label="Middle Name"
                          style="cursor: pointer"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Middle Name"
                            rules=""
                          >
                            <b-form-input
                              id="middleName"
                              v-model="grower.middleName"
                              name="middleName"
                              :state="errors.length > 0 ? false : null"
                              size="sm"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            <small
                              v-if="serverErrors && serverErrors.middleName"
                              class="text-danger"
                            >{{ serverErrors.middleName[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <b-form-group
                          labe-for="lastName"
                          label="Last Name"
                          style="cursor: pointer"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Last Name"
                            rules=""
                          >
                            <b-form-input
                              id="lastName"
                              v-model="grower.lastName"
                              name="lastName"
                              :state="errors.length > 0 ? false : null"
                              size="sm"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                            <small
                              v-if="serverErrors && serverErrors.lastName"
                              class="text-danger"
                            >{{ serverErrors.lastName[0] }}</small>
                            <small
                              v-if="serverErrors && !serverErrors.lastName && serverErrors.person_id"
                              class="text-danger"
                            >{{ serverErrors.person_id[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      labe-for="mobile"
                      label="Phone Number"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Phone Number"
                        rules=""
                      >
                        <b-form-input
                          id="mobile"
                          v-model="grower.mobile"
                          name="mobile"
                          :state="errors.length > 0 ? false : null"
                          size="sm"
                          placeholder="e.g 07XX XXX XXX"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.mobile"
                          class="text-danger"
                        >{{ serverErrors.mobile[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-row style="padding-top:28px;">
                      <b-col cols="12">
                        <b-form-checkbox
                          v-model="grower.isIF"
                          checked="false"
                          class="custom-control-success"
                          name="check-button"
                          switch
                          :disabled="client.type !== 0"
                        >
                          <span class="switch-icon-left">
                            <feather-icon icon="CheckCircleIcon" />
                          </span>
                          <span>Individual Farmer</span>
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-checkbox
                      v-model="grower.isActive"
                      :checked="grower.isActive"
                      class="custom-control-success"
                      name="check-button"
                      switch
                    >
                      <span class="switch-icon-left">
                        <feather-icon icon="CheckCircleIcon" />
                      </span>
                      <span>Is Active</span>
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      labe-for="type"
                      label="Grower Type"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Grower Type"
                        rules=""
                      >
                        <b-form-select
                          id="type"
                          v-model="grower.contract.type"
                          size="sm"
                          name="type"
                          :state="errors.length > 0 ? false : null"
                        >
                          <b-form-select-option :value="0">
                            New
                          </b-form-select-option>
                          <b-form-select-option :value="1">
                            Continuing
                          </b-form-select-option>
                          <b-form-select-option :value="2">
                            Revived
                          </b-form-select-option>
                        </b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.type"
                          class="text-danger"
                        >{{ serverErrors.type[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      labe-for="registrationNumber"
                      label="Registration Number"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Registration Number"
                        rules=""
                      >
                        <b-form-input
                          id="registrationNumber"
                          v-model="grower.registrationNumber"
                          name="registrationNumber"
                          :state="errors.length > 0 ? false : null"
                          size="sm"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.registrationNumber"
                          class="text-danger"
                        >{{ serverErrors.registrationNumber[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="''+client.type === '1'">
                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      labe-for="target"
                      label="KGs Estimated"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="target"
                        rules=""
                      >
                        <b-form-input
                          id="target"
                          v-model="grower.target.value"
                          name="target"
                          :state="errors.length > 0 ? false : null"
                          size="sm"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.target"
                          class="text-danger"
                        >{{ serverErrors.target[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col
                    v-if="''+client.type === '0'"
                    cols="12"
                  >
                    <b-form-group
                      labe-for="society_id"
                      label="Society"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Society"
                        rules=""
                      >
                        <b-form-select
                          id="society_id"
                          v-model="grower.society_id"
                          size="sm"
                          name="society_id"
                          :state="errors.length > 0 ? false : null"
                        >
                          <b-form-select-option :value="null">
                            Select...
                          </b-form-select-option>
                          <b-form-select-option
                            v-for="society in societies"
                            :key="society.id"
                            :value="society.id"
                          >
                            {{ society.name.toUpperCase() }}
                          </b-form-select-option>
                        </b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.society_id"
                          class="text-danger"
                        >{{ serverErrors.society_id[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col cols="12" v-if="''+client.type === '1'">
                                      <b-form-group
                                          labe-for="client_id" label="Society" style="cursor: pointer"
                                      >
                                          <validation-provider #default="{ errors }" name="Society" rules="">
                                              <b-form-select
                                                  size="sm"
                                                  id="client_id"
                                                  name="client_id"
                                                  v-model="grower.client_id"
                                                  :state="errors.length > 0 ? false : null"
                                              >
                                                  <b-form-select-option :value="client.id" selected disabled>
                                                      {{ client.name.trim().toUpperCase() }}
                                                  </b-form-select-option>
                                              </b-form-select>
                                          </validation-provider>
                                      </b-form-group>
                                  </b-col> -->
                </b-row>

                <b-row
                  v-if="''+client.type === '1'"
                  class="mb-1"
                >
                  <b-col cols="12">
                    <location-filters
                      size="sm"
                      align="vertical"
                      @filter="changeFilter"
                    />
                    <small
                      v-if="serverErrors && serverErrors.location_id"
                      class="text-danger"
                    >{{ serverErrors.location_id[0] }}</small>
                  </b-col>
                </b-row>

                <b-row v-if="''+client.type === '1'">
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <h6>Club Membership</h6>
                    <hr style="color: #000000;">
                    <b-row>
                      <b-col
                        cols="12"
                        md="12"
                      >
                        <location-filters
                          size="sm"
                          align="vertical"
                          @filter="clubFilter"
                        />
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col
                        cols="12"
                        md="12"
                      >
                        <b-form-group
                          label-for="club_id"
                          label="Club"
                          style="cursor: pointer"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="club_id"
                            rules=""
                          >
                            <b-form-select
                              id="club_id"
                              v-model="grower.club_id"
                              name="club_id"
                              size="sm"
                              :state="errors.length > 0 ? false : null"
                            >
                              <b-form-select-option :value="null">
                                Select...
                              </b-form-select-option>
                              <b-form-select-option
                                v-for="club in clubs"
                                :key="club.id"
                                :value="club.id"
                              >
                                {{ club.name.toUpperCase() }}
                              </b-form-select-option>
                            </b-form-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                            <small
                              v-if="serverErrors && serverErrors.club_id"
                              class="text-danger"
                            >{{ serverErrors.club_id[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row v-if="''+client.type === '0'">
                  <b-col cols="6">
                    <b-form-group
                      labe-for="sector_id"
                      label="Sector"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Sector"
                        rules=""
                      >
                        <b-form-select
                          id="sector_id"
                          v-model="grower.sector_id"
                          size="sm"
                          name="sector_id"
                          :state="errors.length > 0 ? false : null"
                          @change="populateClubs()"
                        >
                          <b-form-select-option :value="null">
                            Select...
                          </b-form-select-option>
                          <b-form-select-option
                            v-for="sector in sectors"
                            :key="sector.id"
                            :value="sector.id"
                          >
                            {{ sector.code.toUpperCase() }}
                          </b-form-select-option>
                        </b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.sector_id"
                          class="text-danger"
                        >{{ serverErrors.type[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="6">
                    <b-form-group
                      labe-for="club_id"
                      label="Club"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Society"
                        rules=""
                      >
                        <b-form-select
                          id="club_id"
                          v-model="grower.club_id"
                          size="sm"
                          name="club_id"
                          :state="errors.length > 0 ? false : null"
                        >
                          <b-form-select-option :value="null">
                            Select...
                          </b-form-select-option>
                          <b-form-select-option
                            v-for="club in clubs"
                            :key="club.id"
                            :value="club.id"
                          >
                            {{ club.name.toUpperCase() }}
                          </b-form-select-option>
                        </b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.club_id"
                          class="text-danger"
                        >{{ serverErrors.club_id[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="client.type === 0">
                  <b-col cols="3">
                    <b-form-group
                      labe-for="hectares"
                      label="Hectares"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Hectares"
                        rules=""
                      >
                        <b-form-input
                          id="hectares"
                          v-model="grower.contract.hectares"
                          size="sm"
                          name="hectares"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors['contract.hectares']"
                          class="text-danger"
                        >
                          {{ serverErrors['contract.hectares'][0] }}
                        </small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="3">
                    <b-form-group
                      labe-for="labors"
                      label="Labors"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Labors"
                        rules=""
                      >
                        <b-form-input
                          id="labors"
                          v-model="grower.contract.labors"
                          size="sm"
                          name="labors"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.labors"
                          class="text-danger"
                        >{{ serverErrors.labors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="3">
                    <b-form-group
                      label-for="motherBeds"
                      label="M/Beds"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="M/Beds"
                        rules=""
                      >
                        <b-form-input
                          id="motherBeds"
                          v-model="grower.contract.motherBeds"
                          size="sm"
                          name="motherBeds"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.motherBeds"
                          class="text-danger"
                        >{{ serverErrors.motherBeds[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="3">
                    <b-form-group
                      labe-for="resetBeds"
                      label="R/Beds"
                      style="cursor: pointer"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="R/Beds"
                        rules=""
                      >
                        <b-form-input
                          id="resetBeds"
                          v-model="grower.contract.resetBeds"
                          size="sm"
                          name="resetBeds"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.resetBeds"
                          class="text-danger"
                        >{{ serverErrors.resetBeds[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>

        <b-card v-if="client.type === 0">
          <b-card-sub-title>
            <b-row>
              <b-col cols="9">
                Barns
              </b-col>
              <b-col cols="3">
                <b-button
                  size="sm"
                  variant="outline-success"
                  @click="addRow"
                >
                  <feather-icon
                    icon="PlusCircleIcon"
                    class="mr-50"
                  />
                  <span class="align-middle">Add Row</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card-sub-title>
          <b-card-body>
            <table
              class="table table-sm table-condensed"
              width="100%"
            >
              <thead>
                <tr>
                  <th width="3%" />
                  <th
                    class="whitespace-nowrap"
                    width="15%"
                  >
                    Length
                  </th>
                  <th
                    class="whitespace-nowrap"
                    width="15%"
                  >
                    Width
                  </th>
                  <th
                    class="whitespace-nowrap"
                    width="15%"
                  >
                    Tiers
                  </th>
                  <th
                    class="whitespace-nowrap"
                    width="12%"
                  >
                    Slt?
                  </th>
                  <th
                    class="whitespace-nowrap"
                    width="12%"
                  >
                    TV?
                  </th>
                  <th
                    class="whitespace-nowrap"
                    widht="12%"
                  >
                    BV?
                  </th>
                  <th
                    class="whitespace-nowrap"
                    width="19%"
                  >
                    Completed?
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(barn, index) in grower.contract.barns"
                  :key="index"
                >
                  <td align="center">
                    {{ index + 1 }}
                  </td>
                  <td>
                    <div class="col-span-12 sm:col-span-12">
                      <b-form-input
                        v-model="grower.contract.barns[index].length"
                        type="number"
                        size="sm"
                        name="length"
                      />
                    </div>
                  </td>
                  <td>
                    <div class="col-span-12 sm:col-span-12">
                      <b-form-input
                        v-model="grower.contract.barns[index].width"
                        type="number"
                        size="sm"
                        name="width"
                      />
                    </div>
                  </td>
                  <td>
                    <b-form-input
                      v-model="grower.contract.barns[index].tiers"
                      type="number"
                      size="sm"
                      name="tiers"
                    />
                  </td>
                  <td>
                    <b-form-checkbox
                      v-model="grower.contract.barns[index].slot"
                      checked="false"
                      class="custom-control-success"
                      name="slot"
                      switch
                    >
                      <span class="switch-icon-left">
                        <feather-icon icon="CheckCircleIcon" />
                      </span>
                    </b-form-checkbox>
                  </td>
                  <td>
                    <b-form-checkbox
                      v-model="grower.contract.barns[index].topVent"
                      checked="false"
                      class="custom-control-success"
                      name="topVent"
                      switch
                    >
                      <span class="switch-icon-left">
                        <feather-icon icon="CheckCircleIcon" />
                      </span>
                    </b-form-checkbox>
                  </td>
                  <td>
                    <b-form-checkbox
                      v-model="grower.contract.barns[index].bottomVent"
                      checked="false"
                      class="custom-control-success"
                      name="bottomVent"
                      switch
                    >
                      <span class="switch-icon-left">
                        <feather-icon
                          icon="CheckCircleIcon"
                          variant="danger"
                        />
                      </span>
                    </b-form-checkbox>
                  </td>
                  <td align="center">
                    <b-form-checkbox
                      v-model="grower.contract.barns[index].isComplete"
                      checked="false"
                      class="custom-control-success"
                      name="isComplete"
                      switch
                    >
                      <span class="switch-icon-left">
                        <feather-icon icon="CheckCircleIcon" />
                      </span>
                    </b-form-checkbox>
                  </td>
                  <td>
                    <span
                      title="Delete Barn"
                      style="cursor:pointer"
                      @click="removeRow(index)"
                    >
                      <feather-icon
                        class="ml-4 pr-0 cursor-pointer"
                        size="16"
                        icon="Trash2Icon"
                      />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card-body>
        </b-card>
        <!-- <b-card>
                  {{ grower }}
              </b-card> -->
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Form Modal -->
    <b-modal
      id="modal-society-form"
      ref="externalModal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      size="sm"
      @ok="getGrowers"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5>Region Growers</h5>

        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="success"
          :disabled="getting"
          @click="ok()"
        >
          <b-spinner
            v-if="getting"
            small
            class="mr-1"
            label="Small Spinner"
          />
          <span v-if="!getting">Get</span>
          <span v-if="getting">Getting...</span>
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{}">
        <validation-observer
          ref="dataForm"
          #default="{ invalid }"
        >
          <b-form
            ref="form"
            @submit.stop.prevent="handleGet"
          >
            <b-row>
              <b-col
                cols="12"
                md="12"
              >
                <b-form-group
                  label-for="region_code"
                  label="Region Code"
                  style="cursor: pointer"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Registration Number"
                    rules="required"
                  >
                    <b-form-input
                      id="region_code"
                      v-model="region_code"
                      name="region_code"
                      :state="errors.length > 0 ? false : null"
                      size="sm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.region_code"
                      class="text-danger"
                    >{{ serverErrors.region_code[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Filter Location</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="mb-md-0 mb-2"
          >
            <b-row>
              <b-col
                cols="12"
                md="12"
                class="mb-md-0 mb-2"
              >
                <location-filters
                  size="sm"
                  align="horizontal"
                  :selected-locations="defaultSelectedLocations"
                  @filter="changeFilter"
                />
                <small
                  v-if="requiresLocationSelection"
                  class="text-muted d-block mt-50"
                >Select a region and area to load growers.</small>
              </b-col>
            </b-row>
          </b-col>

          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <label>
              Size: {{ parseFloat(file.size).toFixed(1) }}{{ file.unit }}/30MB
              <small
                v-if="serverErrors && serverErrors.fileInput"
                style="color: tomato"
              >
                {{ serverErrors.fileInput[0] }}
              </small>
            </label><br>
            <b-button
              size="sm"
              variant="outline-success"
              :disabled="uploading"
              @click="openFileBrowser()"
            >
              <b-spinner
                v-if="uploading"
                small
                class="mr-1"
                label="Small Spinner"
              />
              <span v-if="uploading"> Uploading...</span>
              <span v-if="!uploading">Upload Growers</span>
              <feather-icon
                icon="UploadCloudIcon"
                class="ml-1"
              />
            </b-button><br>
            {{ file.orginalName }}
            <input
              ref="fileInput"
              type="file"
              style="visibility: hidden;"
              @change="convertFile"
            >
          </b-col>
          <b-col
            v-if="client.type == 1"
            cols="12"
            md="3"
            class="pt-2"
          >
            <b-button
              variant="flat-success"
              class="btn-icon float-right"
              size="sm"
              title="Download Excel"
              @click="downloadList(true)"
            >
              <img
                src="@/assets/images/icons/export_xls.png"
                width="24"
                height="24"
              >
            </b-button>

            <b-button
              variant="flat-danger"
              class="btn-icon mr-1 float-right"
              size="sm"
              title="Download pdf"
              @click="downloadList(false)"
            >
              <img
                src="@/assets/images/icons/pdf_export.png"
                width="24"
                height="24"
              >
            </b-button>
          </b-col>
        </b-row>
        <!-- <b-card>{{ file }}</b-card> -->
      </b-card-body>
    </b-card>
    <!-- ./Filters -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search & Button -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
                size="sm"
              />
              <b-button
                variant="primary"
                size="sm"
                @click="invokeCreateForm()"
              >
                <span class="text-nowrap">Register Grower</span>
              </b-button>

              <b-button
                variant="outline-success"
                size="sm"
                class="ml-1"
                @click="invokeExternal()"
              >
                <span class="text-nowrap">External Growers</span>
              </b-button>
            </div>
          </b-col>
          <!-- ./Search & Button-->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        ref="records"
        striped
        hover
        small
        class="position-relative"
        :items="rows"
        :busy="isLoading"
        responsive
        :fields="columns"
        :tbody-tr-class="resolveVolumeRowClass"
        no-local-sorting
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="emptyStateText"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #table-busy>
          <div class="text-center text-muted my-2">
            <b-spinner class="align-middle mr-50" />
            <strong>Loading growers...</strong>
          </div>
        </template>

        <!-- Dynamic change the address column to final level -->
        <template #head(address)="data">
          <span v-if="selections.length > 0">{{ selections[selections.length - 1].label }}</span>
        </template>

        <!-- Extract columns data -->
        <template #cell(name)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(resolveDisplayGrowerName(data.item))"
                :variant="`light-${resolveGrowerTypeVariant(resolveDisplayGrowerType(data.item))}`"
                :to="{ path: 'growers/' + data.item.id }"
              />
            </template>
            <b-link
              :to="{ path: 'growers/' + data.item.id }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ resolveDisplayGrowerName(data.item) || 'Unknown Grower' }}
            </b-link>
            <small
              v-if="resolveDisplayReferenceNumber(data.item) || resolveDisplayRegistrationNumber(data.item)"
              class="text-muted"
            >Reference: {{ resolveDisplayReferenceNumber(data.item) || resolveDisplayRegistrationNumber(data.item) }}</small>
          </b-media>
        </template>

        <template #cell(gender)="data">
          {{ resolveDisplayGender(data.item) || 'Unknown' }}
        </template>

        <template #cell(referenceNumber)="data">
          <span>{{ resolveDisplayReferenceNumber(data.item) || 'N/A' }}</span>
        </template>

        <template #cell(registrationNumber)="data">
          <span>{{ resolveDisplayRegistrationNumber(data.item) || 'N/A' }}</span>
        </template>

        <template #cell(type)="data">
          <span>{{ resolveDisplayGrowerType(data.item) || 'N/A' }}</span>
        </template>

        <template #cell(societyName)="data">
          <span>{{ resolveDisplaySocietyName(data.item) || 'N/A' }}</span>
        </template>

        <template #cell(address)="data">
          <span v-if="data.item.address">
            {{ data.item.address.location.name.trim().toUpperCase() }}
          </span>
        </template>

        <template #cell(sustainableVolume)="data">
          <span>{{ formatVolume(resolveSustainableVolume(data.item)) }}</span>
        </template>

        <template #cell(lockedVolume)="data">
          <span>{{ formatVolume(resolveLockedVolume(data.item)) }}</span>
        </template>

        <template #cell(soldVolume)="data">
          <span>{{ formatVolume(resolveSoldVolume(data.item)) }}</span>
        </template>

        <template #cell(hectares)="data">
          <span v-if="data.item.contracts && data.item.contracts.length > 0">{{ parseFloat(data.item.contracts[0].hectares).toFixed(1) }}</span>
        </template>

        <template #cell(labors)="data">
          <span v-if="data.item.contracts && data.item.contracts.length > 0">{{ data.item.contracts[0].labors }}</span>
        </template>

        <template #cell(motherBeds)="data">
          <span v-if="data.item.contracts && data.item.contracts.length > 0">{{ data.item.contracts[0].motherBeds }}</span>
        </template>

        <template #cell(resetBeds)="data">
          <span v-if="data.item.contracts && data.item.contracts.length > 0">{{ data.item.contracts[0].resetBeds }}</span>
        </template>

        <template #cell(targets)="data">
          <span v-if="data.item.contract && data.item.contract.targets.length > 0">
            {{ parseFloat(data.item.contract.targets[data.item.contract.targets.length - 1].value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
          </span>
          <span v-else>N/A</span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item :to="{ path: 'growers/' + data.item.id }">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item @click="invokeUpdateForm(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item
              :disabled="cloningGrowerId === data.item.id"
              @click="cloneGrower(data.item)"
            >
              <feather-icon icon="CopyIcon" />
              <span
                v-if="cloningGrowerId !== data.item.id"
                class="align-middle ml-50"
              >Clone</span>
              <span
                v-else
                class="align-middle ml-50"
              >Cloning...</span>
            </b-dropdown-item>

            <b-dropdown-item @click="remove(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>

    </b-card>
    <!-- ./Table Container Card -->
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BRow, BCol, BModal, VBModal, BButton, BTable,
    BBadge, BDropdown, BDropdownItem, BPagination, BSpinner, BMedia, BAvatar, BLink,
    BForm, BFormGroup, BFormSelect, BFormSelectOption, BFormInput,
    BFormCheckbox,
    BCard, BCardHeader, BCardSubTitle, BCardBody,
} from 'bootstrap-vue'
import LocationFilters from '@core/components/cromis/filters/LocationFilters.vue'
import { required, integer } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import growersStoreModule from '@/views/cromis/grower/growersStoreModule'
import useGrowersList from '@/views/cromis/grower/useGrowersList'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        BCard,
        BCardHeader,
        BCardSubTitle,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BFormSelectOption,
        BFormCheckbox,
        BModal,
        BButton,
        BSpinner,
        BMedia,
        BLink,
        BAvatar,
        BTable,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,

        vSelect,
        ValidationProvider,
        ValidationObserver,

        LocationFilters,
    },
    directives: {
        'b-modal': VBModal,
    },
    props: {},

    setup(props, context) {
        const toast = useToast()
        const dataForm = ref(null)
        const myModal = ref(null)
        const externalModal = ref(null)
        const fileInput = ref(null)
        const saving = ref(false)
        const uploading = ref(false)
        const getting = ref(false)
        const cloningGrowerId = ref(null)
        const serverErrors = ref(null)

        const selections = ref([])
        const levels = ref(null)
        const children = ref([])
        const societies = ref([])
        const sectors = ref([])
        const clubs = ref([])

        const client = ref(JSON.parse(localStorage.getItem('userData')).client)

        const file = ref({
            document: null,
            type: null,
            size: 0,
            unit: 'KB',
            originalName: null,
            location_id: null,
            contents: 'growers',
        })

        const grower = ref({
            id: null,
            firstName: null,
            middleName: null,
            lastName: null,
            gender: null,
            mobile: null,
            isIF: client.value.type === 1,
            registrationNumber: null,
            society_id: `${client.value.type}` == '1' ? client.value.id : null,
            client_id: `${client.value.type}` !== '0' ? client.value.id : null,
            sector_id: null,
            club_id: null,
            isActive: true,
            location_id: null,
            contract: client.value.type === 0 ? {
                hectares: 0,
                labors: 1,
                type: 1,
                motherBeds: 0,
                resetBeds: 0,
                barns: [
                    {
                        length: 0,
                        width: 0,
                        tiers: 0,
                        topVent: false,
                        bottomVent: false,
                        slot: false,
                        isComplete: false,
                    },
                ],
            } : {
                hectares: 0,
                labors: 1,
                type: 1,
                motherBeds: 0,
                resetBeds: 0,
                barns: [],
            },
            target: {
                id: null,
                value: null,
                target_id: null,
                target_type: null,
            },
        })

        const region_code = ref(null)

        const CROMIS_GROWER_STORE_MODULE_NAME = 'cromis-grower'

        // Register module
        if (!store.hasModule(CROMIS_GROWER_STORE_MODULE_NAME)) store.registerModule(CROMIS_GROWER_STORE_MODULE_NAME, growersStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_GROWER_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_GROWER_STORE_MODULE_NAME)
        })

        const isAddNewUserSidebarActive = ref(false)

        onMounted(async () => {
            await store.dispatch('cromis-grower/levels')
                .then(response => {
                    levels.value = response.data.levels[0]

                    selections.value.push({
                        level: levels.value.name.toLowerCase(),
                        model: null,
                        label: levels.value.name,
                        child: levels.value.children.length > 0 ? levels.value.children[0].name.toLowerCase() : null,
                        locations: [],
                    })

                    let list = levels.value.children

                    while (list.length > 0) {
                        children.value.push(list[0])
                        if (list[0].children > 0) {
                            selections.value.push({
                                level: list[0].name.toLowerCase(), model: null, label: list[0].name, child: list[0].children[0].name.toLowerCase(), locations: [],
                            })
                        } else {
                            selections.value.push({
                                level: list[0].name.toLowerCase(), model: null, label: list[0].name, child: null, locations: [],
                            })
                        }

                        list = list[0].children
                    }
                })
                .catch(error => {
                    console.log('got error', error)
                })

            await store.dispatch('cromis-grower/locations')
                .then(response => {
                    populateSelections(response.data.locations)
                })
                .catch(error => {
                    console.log('got error', error)
                })
        })

        const populateSelections = locations => {
            for (let i = 0; i < locations.length; i++) {
                for (let x = 0; x < selections.value.length; x++) {
                    if (locations[i].level.name.toLowerCase() === selections.value[x].level) {
                        selections.value[x].locations.push(locations[i])
                    }
                }
            }
        }

        const toVolumeNumber = value => {
            const volume = Number(value)

            return Number.isFinite(volume) ? volume : 0
        }

        const formatVolume = value => toVolumeNumber(value).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })

        const normalizeText = value => {
            if (value === null || value === undefined) {
                return ''
            }

            return `${value}`.trim()
        }

        const resolveDisplayGrowerName = item => {
            const explicitName = normalizeText(item?.name || item?.grower_name || item?.growerName)

            if (explicitName) {
                return explicitName
            }

            return [
                normalizeText(item?.person?.firstName),
                normalizeText(item?.person?.middleName),
                normalizeText(item?.person?.lastName),
            ].filter(Boolean).join(' ')
        }

        const resolveDisplayGender = item => {
            const gender = normalizeText(item?.gender || item?.person?.gender)

            if (!gender) {
                return ''
            }

            return gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase()
        }

        const resolveDisplayReferenceNumber = item => normalizeText(
            item?.referenceNumber ?? item?.reference_number ?? item?.reference,
        )

        const resolveDisplayRegistrationNumber = item => normalizeText(
            item?.registrationNumber ?? item?.registration_number,
        )

        const resolveDisplayGrowerType = item => normalizeText(item?.type).toUpperCase()

        const resolveDisplaySocietyName = item => normalizeText(
            item?.societyName ?? item?.society_name ?? item?.society?.name,
        )

        const resolveLockedVolume = item => toVolumeNumber(
            item?.lockedVolume ?? item?.locked_volume ?? item?.locked_vol,
        )

        const resolveSustainableVolume = item => toVolumeNumber(
            item?.sustainableVolume ?? item?.sustainable_volume ?? item?.sustainable_max_vol ?? item?.sustainable_vol,
        )

        const resolveSoldVolume = item => toVolumeNumber(
            item?.soldVolume ?? item?.sold_volume,
        )

        const resolveVolumeRowClass = item => {
            if (!item) {
                return ''
            }

            const soldVolume = resolveSoldVolume(item)
            const lockedVolume = resolveLockedVolume(item)
            const sustainableVolume = resolveSustainableVolume(item)
            const exceedsLockedVolume = soldVolume > lockedVolume
            const exceedsSustainableVolume = soldVolume > sustainableVolume

            if (exceedsLockedVolume && exceedsSustainableVolume) {
                return 'table-danger'
            }

            if (exceedsLockedVolume || exceedsSustainableVolume) {
                return 'table-warning'
            }

            return ''
        }

        const changeFilter = filteredValue => {
            grower.value.location_id = filteredValue != null ? filteredValue.id : null
            const hasChildren = Array.isArray(filteredValue?.children) && filteredValue.children.length > 0
            const selectedLevel = normalizeText(filteredValue?.level?.name).toLowerCase()
            const isAreaSelection = !!filteredValue && (selectedLevel === 'area' || !hasChildren)

            locationFilter.value = isAreaSelection ? filteredValue.id : null
        }

        const clubFilter = async filteredValue => {
            await store.dispatch('cromis-grower/clubs', { location_id: filteredValue != null ? filteredValue.id : null })
                .then(response => {
                    clubs.value = response.data.clubs
                })
                .catch(error => {
                    console.log('got error', error)
                })
        }

        const downloadList = async isExcel => {
            console.log(isExcel)
            const type = isExcel ? 1 : 0
            console.log(client.value)
            await window.open(`${axios.defaults.baseURL}/reports/markets_list?view=${client.value.id}&type=${type}&location_id=${locationFilter.value}`, '_blank')
        }

        const populateClubs = async () => {
            await store.dispatch('cromis-grower/clubs', { sector_id: grower.value.sector_id })
                .then(response => {
                    clubs.value = response.data.clubs
                })
                .catch(error => {
                    console.log('got error', error)
                })
        }

        const openFileBrowser = () => {
            fileInput.value.click()
        }

        const convertFile = e => {
            file.value = {
                document: null,
                type: null,
                size: 0,
                unit: 'KB',
                originalName: null,
                location_id: null,
                contents: 'growers',
            }

            const rawFile = e.target.files[0]

            file.value.originalName = rawFile.name
            file.value.size = rawFile.size / 1048576 < 1
                ? rawFile.size / 1024 : rawFile.size / 1048576
            file.value.unit = rawFile.size / 1048576 < 1 ? 'KB' : 'MB'
            file.value.type = rawFile.type

            serverErrors.value = null
            uploading.value = false

            if (file.value.size > 30 && file.value.unit === 'MB') {
                serverErrors.value = {
                    fileInput: [
                        'File size exceeded (Max 30MB)',
                    ],
                }
            } else {
                const name = file.value.originalName
                if (!['csv', 'xls', 'xlsx'].includes(name.substring(name.indexOf('.') + 1))) {
                    serverErrors.value = {
                        fileInput: [
                            'Invalid file type, required excel file (csv, xlsx or xls)',
                        ],
                    }
                }
            }

            const reader = new FileReader()

            reader.onloadend = async () => {
                file.value.document = await reader.result

                if (!serverErrors.value || !serverErrors.value.fileInput) {
                    // file.value.location_id = selections.value[selections.value.length - 1].model.id
                    uploading.value = true
                    await store.dispatch('cromis-grower/imports', file.value)
                        .then(response => {
                            refetch()
                            uploading.value = false

                            file.value = {
                                document: null,
                                type: null,
                                size: 0,
                                unit: 'KB',
                                originalName: null,
                                location_id: null,
                                content: 'growers',
                            }

                            toast({
                                component: ToastificationContent,
                                props: {
                                    title: response.data.message,
                                    icon: 'AlertTriangleIcon',
                                    variant: 'success',
                                },
                            })
                        })
                        .catch(error => {
                            uploading.value = false
                            context.root.$swal({
                                icon: 'error',
                                title: `${error.response.status} ${error.response.statusText}`,
                                text: error.response.data.message,
                                showConfirmButton: true,
                                customClass: {
                                    confirmButton: 'btn btn-outline-danger',
                                },
                                buttonsStyling: false,
                            })
                        })
                } else {
                    uploading.value = false
                }
            }

            reader.readAsDataURL(rawFile)
        }

        // Methods for dynamic table rows
        const addRow = () => {
            const barn = {
                length: 0,
                width: 0,
                tiers: 0,
                slot: false,
                bottomVent: false,
                topVent: false,
                isComplete: false,
            }
            grower.value.contract.barns.push(barn)
        }

        const removeRow = index => {
            grower.value.contract.barns.splice(index, 1)
        }

        const {
            rows,
            isLoading,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            isSuperUser,
            requiresLocationSelection,
            emptyStateText,
            defaultSelectedLocations,

            // UI
            // resolveUserRoleVariant,
            // resolveUserRoleIcon,
            resolveGrowerTypeVariant,
            resolveStatusVariant,

            // Filers
            locationFilter,
        } = useGrowersList()

        const buildGrowerFormState = item => {
            const barns = []
            const latestContract = item.contracts && item.contracts.length > 0
                ? item.contracts[item.contracts.length - 1]
                : null
            const latestTarget = item.contract && item.contract.targets && item.contract.targets.length > 0
                ? item.contract.targets[item.contract.targets.length - 1]
                : null

            if (client.value.type == 0 && latestContract && latestContract.barns) {
                for (let i = 0; i < latestContract.barns.length; i++) {
                    barns.push({
                        length: latestContract.barns[i].length,
                        width: latestContract.barns[i].width,
                        tiers: latestContract.barns[i].tiers,
                        topVent: !!latestContract.barns[i].topVent,
                        bottomVent: !!latestContract.barns[i].bottomVent,
                        slot: !!latestContract.barns[i].slot,
                        isComplete: !!latestContract.barns[i].isComplete,
                    })
                }
            }

            return {
                id: item.id,
                firstName: item.person.firstName,
                middleName: item.person.middleName,
                lastName: item.person.lastName,
                gender: item.person.gender,
                mobile: item.mobile,
                isIF: item.isIF,
                registrationNumber: item.registrationNumber,
                society_id: client.value.type == 0 ? (item.society ? item.society.id : null) : (client.value.type == 1 ? client.value.id : null),
                client_id: client.value.id,
                sector_id: client.value.type == 0 ? (item.sector ? item.sector.id : null) : null,
                club_id: client.value.type == 0 ? (item.club ? item.club.id : null) : null,
                isActive: item.isActive,
                location_id: selections.value[selections.value.length - 1].model !== null ? selections.value[selections.value.length - 1].model.id : null,
                contract: client.value.type == 0 ? {
                    hectares: latestContract ? latestContract.hectares : 0,
                    labors: latestContract ? latestContract.labors : 1,
                    type: latestContract ? latestContract.type : 1,
                    motherBeds: latestContract ? latestContract.motherBeds : 0,
                    resetBeds: latestContract ? latestContract.resetBeds : 0,
                    barns,
                } : {
                    hectares: 1,
                    labors: 1,
                    type: 1,
                    motherBeds: 1,
                    resetBeds: 1,
                    barns: [],
                },
                target: client.value.type !== 0 ? {
                    id: latestTarget ? latestTarget.id : null,
                    value: latestTarget ? latestTarget.value : null,
                    target_id: item.contract ? item.contract.id : null,
                    target_type: 2, // 0 person, 1 grower, 2 contract, 3 location
                } : {
                    id: null, value: null, target_id: null, target_type: null,
                },
            }
        }

        // Methods
        const invokeUpdateForm = async item => {
            try {
                const growerId = item.id || item.growerId || item.grower_id
                const growerDetails = item.person && item.contracts
                    ? item
                    : (await store.dispatch('cromis-grower/show', { id: growerId })).data

                grower.value = buildGrowerFormState(growerDetails)

                await populateClubs()

                myModal.value.show()
            } catch (error) {
                context.root.$swal({
                    icon: 'error',
                    title: error.response ? `${error.response.status} ${error.response.statusText}` : 'Server Error',
                    text: error.response?.data?.message || 'Failed to load grower details',
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    },
                    buttonsStyling: false,
                })
            }
        }

        const invokeCreateForm = () => {
            grower.value = {
                id: null,
                firstName: null,
                middleName: null,
                lastName: null,
                gender: null,
                isIF: client.value.type === 1,
                registrationNumber: null,
                society_id: `${client.value.type}` == '1' ? client.value.id : null,
                client_id: `${client.value.type}` !== '0' ? client.value.id : null,
                sector_id: null,
                club_id: null,
                isActive: true,
                location_id: selections.value[selections.value.length - 1].model !== null ? selections.value[selections.value.length - 1].model.id : null,
                contract: client.value.type === 0 ? {
                    hectares: 0,
                    labors: 1,
                    type: 1,
                    motherBeds: 0,
                    resetBeds: 0,
                    barns: [
                        {
                            length: 0,
                            width: 0,
                            tiers: 0,
                            topVent: false,
                            bottomVent: false,
                            slot: false,
                            isComplete: false,
                        },
                    ],
                } : {
                    hectares: 0,
                    labors: 1,
                    type: 1,
                    motherBeds: 0,
                    resetBeds: 0,
                    barns: [],
                },
                target: {
                    id: null,
                    value: null,
                    target_id: null,
                    target_type: null,
                },
            }

            myModal.value.show()
        }

        const invokeExternal = () => {
            region_code.value = null

            externalModal.value.show()
        }

        const isFormValid = async () => {
            let isValid = false
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = bvModalEvt => {
            bvModalEvt.preventDefault()

            serverErrors.value = null
            // Handle form submit
            if (grower.value.id === null || grower.value.id === 0) handleCreate()
            else handleUpdate(grower.value)
        }

        const getGrowers = byModalEvt => {
            byModalEvt.preventDefault()

            serverErrors.value = null

            if (region_code.value != null) handleGetGrowers()
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-grower/create', grower.value)
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: `Grower ${response.data.person.firstName} ${response.data.person.lastName} has been saved successfully!`,
                        showConfirmButton: true,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdate = async item => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            console.log('item', item)

            await store.dispatch('cromis-grower/update', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: `Changes to grower ${response.data.person.firstName} ${response.data.person.lastName} has been saved successfully!`,
                        showConfirmButton: false,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleGetGrowers = async () => {
            getting.value = true
            const valid = await isFormValid()

            if (!valid) {
                getting.value = false
                return
            }

            console.log(region_code.value)

            await store.dispatch('cromis-grower/externalGrowers', { region_code: region_code.value })
                .then(response => {
                    getting.value = false
                    externalModal.value.hide()

                    refetch()
                })
                .catch(error => {
                    getting.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const remove = async id => {
            await store.dispatch('cromis-grower/remove', id)
                .then(response => {
                    refetch()
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: false,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        }

        const cloneGrower = async item => {
            cloningGrowerId.value = item.id

            await store.dispatch('cromis-grower/cloneExcessVolume', { grower_id: item.id })
                .then(response => {
                    refetch()

                    context.root.$swal({
                        icon: 'success',
                        text: response.data.message || `Grower ${item.name || item.id} has been cloned successfully!`,
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    const errorMessage = error.response?.data?.message || 'Something went wrong. See tech support'

                    context.root.$swal({
                        icon: 'error',
                        title: error.response ? `${error.response.status} ${error.response.statusText}` : 'Server Error',
                        text: errorMessage,
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
                .finally(() => {
                    cloningGrowerId.value = null
                })
        }

        return {
            client,

            // Sidebar
            isAddNewUserSidebarActive,

            rows,
            isLoading,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            isSuperUser,
            requiresLocationSelection,
            emptyStateText,
            defaultSelectedLocations,

            // Filter
            avatarText,
            formatVolume,
            changeFilter,
            clubFilter,
            downloadList,
            openFileBrowser,
            convertFile,
            locationFilter,
            fileInput,
            file,

            // UI
            // resolveUserRoleVariant,
            // resolveUserRoleIcon,
            resolveGrowerTypeVariant,
            resolveDisplayGrowerName,
            resolveDisplayGender,
            resolveDisplayReferenceNumber,
            resolveDisplayRegistrationNumber,
            resolveDisplayGrowerType,
            resolveDisplaySocietyName,
            resolveLockedVolume,
            resolveSustainableVolume,
            resolveSoldVolume,
            resolveVolumeRowClass,
            resolveStatusVariant,

            // Form Data
            grower,
            region_code,

            // Validations
            required,
            integer,

            // Methods and Form refs
            myModal,
            externalModal,
            saving,
            uploading,
            getting,
            cloningGrowerId,
            serverErrors,
            dataForm,
            invokeCreateForm,
            invokeUpdateForm,
            invokeExternal,
            isFormValid,
            submit,
            getGrowers,
            handleCreate,
            handleUpdate,
            handleGetGrowers,
            cloneGrower,
            remove,
            selections,
            levels,
            children,
            societies,
            sectors,
            clubs,
            removeRow,
            addRow,
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
